module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy-title"
  }, [_vm._v("The Little Lark Still Sings")]), _vm._v(" "), _c('p', {
    staticClass: "copy-sub"
  }, [_vm._v("A True Story of Love, Change & an Old Tuscan Farmhouse")]), _vm._v(" "), _c('p', {
    staticClass: "copy-top"
  }, [_vm._v("© 2021 Victoria Smith")]), _vm._v(" "), _c('p', {
    staticClass: "copy-top"
  }, [_vm._v("All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy-top"
  }, [_vm._v("Published in New York, New York, by Morgan James Publishing. Morgan James is a trademark of Morgan James, LLC. "), _c('a', {
    attrs: {
      "href": "http://www.MorganJamesPublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.MorganJamesPublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy-top"
  }, [_vm._v("ISBN 9781631952197 paperback")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 9781631952203 eBook")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Library of Congress Control Number: 2020938582")]), _vm._v(" "), _c('p', {
    staticClass: "copys"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cover Design:")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Rachel Lopez")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "href": "http://www.r2cdesign.com",
      "target": "_blank"
    }
  }, [_vm._v("www.r2cdesign.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copys"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Interior Design:")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Chris Treccani")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "href": "http://www.3dogcreative.net",
      "target": "_blank"
    }
  }, [_vm._v("www.3dogcreative.net")])]), _vm._v(" "), _c('p', {
    staticClass: "copys"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cover and Author Photos:")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Mikael Melbye")]), _vm._v(" "), _c('p', {
    staticClass: "copys"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lark Drawing:")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Barry Svigals")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy-j"
  }, [_vm._v("Morgan James is a proud partner of Habitat for Humanity Peninsula and Greater Williamsburg. Partners in building since 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "copy-top2"
  }, [_vm._v("Get involved today! Visit"), _c('br'), _c('a', {
    attrs: {
      "href": "http://MorganJamesPublishing.com/giving-back",
      "target": "_blank"
    }
  }, [_vm._v("MorganJamesPublishing.com/giving-back")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fad2c05a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copy.vue
// module id = 66
// module chunks = 0